<div class="d-flex align-items-center">
  <a class="week-nav clickable me-2" (click)="scroll(-1)"><gray-icon icon="arrow-left"></gray-icon></a>

  <div class="week-strip d-flex align-items-center flex-grow-1" #strip>
    <a class="week-name fw-800 fs-large clickable px-3 py-1" *ngFor="let week of weeks"
       [class.active]="week.id === selectedWeekId" (click)="weekSelected.emit(week)">
      {{'planner.week_number'|translate: {week: week.weekNumber} }}
    </a>
  </div>

  <a class="week-nav clickable ms-2" (click)="scroll(1)"><gray-icon icon="arrow-right"></gray-icon></a>
</div>
